import type { SessionTerminationResponse } from 'src/types/session';
import deleteWithReason from './deleteWithReason';

interface DeleteAllSessionsAdminParams {
  tenantId?: string;
  reason?: string;
}

const deleteAllSessionsAdmin = async (
  params?: DeleteAllSessionsAdminParams,
): Promise<SessionTerminationResponse> => {
  return deleteWithReason({
    pathType: 'admin',
    tenantId: params?.tenantId,
    reason: params?.reason,
  });
};

export default deleteAllSessionsAdmin;
